module.exports = __webpack_public_path__ + "static/Teri4-0aeb688bf6b13b98bdec81709fe20976.jpg";